<template>
	<page>
		<module>
			<view-list :work-type="workType" ref="view" selector :view-config="auth('b_stockin_viewmanage')">
				<template #search>
					<m-search ref="search">
						<m-search-item label="入库单号">
							<c-input name="order_code"></c-input>
						</m-search-item>
						<m-search-item label="批次号" v-if="systemConfig.batch_stock == 1">
							<c-input name="batch_code"></c-input>
						</m-search-item>
						<m-search-item label="业务分类">
							<c-select name="order_classify" async multiple @search="searchOrderClassify"></c-select>
						</m-search-item>
						<m-search-item label="来源单据号">
							<c-input name="ref_code"></c-input>
						</m-search-item>
						<m-search-item label="备注">
							<c-input name="remark"></c-input>
						</m-search-item>
						<m-search-item label="入库时间" colspan="2">
							<c-datetime range start-name="start_date" end-name="end_date"></c-datetime>
						</m-search-item>
						<m-search-item label="客户">
							<c-select name="customer_ids" async multiple @search="searchCustomer"></c-select>
						</m-search-item>
						<m-search-item label="供应商">
							<c-select name="supplier_ids" async multiple @search="searchSupplier"></c-select>
						</m-search-item>
					</m-search>
				</template>

				<template #operate>
					<c-button color="main" v-if="auth('b_stockin_create')" v-lock="lock('b_stockin_create')" prepend-icon="tf-add" @click="$refs.stockinEdit.open()">创建入库单</c-button>
					<c-button v-if="auth('b_stockin_export')" v-lock="lock('b_stockin_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stockin_export')" v-lock="lock('b_stockin_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button  prepend-icon="tf-import" @click="importData()">导入</c-button>
				</template>
				
				<template #batchOperate="{data}">
					<c-button v-if="auth('b_stockin_export')" v-lock="lock('b_stockin_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId()">导出</c-button>
					<c-button v-if="auth('b_stockin_export')" v-lock="lock('b_stockin_export')" prepend-icon="tf-export" @click="$refs.view.exportListByViewId(3)">按模板导出</c-button>
					<c-button v-if="auth('b_stockin_print')" v-lock="lock('b_stockin_print')" prepend-icon="tf-print" @click="$refs.view.batchExportByTemplate()">打印</c-button>
					<c-button v-if="auth('b_stockin_approve')" v-lock="lock('b_stockin_approve')" prepend-icon="tf-approve" @click="approve()">审批</c-button>
					<c-button v-if="auth('b_stockin_approve')" v-lock="lock('b_stockin_approve')" prepend-icon="tf-recall" @click="cancelApprove()">撤回</c-button>
					<c-button v-if="auth('b_stockin_delete')" v-lock="lock('b_stockin_delete')" prepend-icon="tf-trash" color="red" :hollow="true" @click="remove()">删除</c-button>
				</template>

				<template #otherOperate>
					<c-button prepend-icon="tf-import-record" @click="loadImportLogDetail()">导入记录</c-button>
				</template>

				<template #order_code="{data}">
					<c-link @click="globalDialog('stockinDetail', {props: {id: data.id}})">{{data.order_code}}</c-link>
				</template>

				<!--【入库】业务分类-->
				<template #order_classify="{data}">
					<c-state dict="stockinClassifyName" :value="data.order_classify"></c-state>
				</template>
				<!--【入库】来源单据类型-->
				<template #ref_type="{data}">
					<c-state dict="refTypeName" :value="data.ref_type"></c-state>
				</template>
				<!--关联单据-->
				<template #ref_id="{data}">
					<order-link :type="data.ref_type" :id="data.ref_id" :code="data.ref_code"></order-link>
				</template>
				<!--【入库】备注-->
				<template #remark="{data}">
					<span v-if="data.remark">{{data.remark}}</span>
					<span v-else>-</span>
				</template>
				<!--审批状态-->
				<template #approve_state="{data}">
                    <c-state dict="approveStateDic" tag :value="data.approve_state"></c-state>
				</template>
				<!--审批时间-->
				<template #approve_date="{data}">
                    <span v-if="data.approve_date">{{data.approve_date}}</span>
                    <span v-else>-</span>
				</template>
				<!--审批人-->
				<template #approve_user_realname="{data}">
                    <span v-if="data.approve_user_realname">{{data.approve_user_realname}}</span>
                    <span v-else>-</span>
				</template>

				<c-table-column
					type="button"
					label="操作"
					width="180"
					button-limit="3"
				>
					<template #default="{data}">
                        <!--
                            可以编辑的条件如下（满足其一即可）
                            1、无需审批
                            2、需要审批且尚未审批（或已经撤销）
                        -->
						<c-table-button v-if="auth('b_stockin_edit')" v-lock="lock('b_stockin_edit')" :disabled="!(data.approve_state == 1)" icon="tf-edit" @click="$refs.stockinEdit.open(data)">编辑</c-table-button>
						<c-table-button icon="tf-detail" @click="globalDialog('stockinDetail', {props: {id: data.id}})">查看</c-table-button>
						<c-table-button v-if="auth('b_stockin_approve')" v-lock="lock('b_stockin_approve')" :disabled="!(data.approve_state == 1)" icon="tf-approve" @click="approve(data)">审批</c-table-button>
						<c-table-button v-if="auth('b_stockin_approve')" v-lock="lock('b_stockin_approve')" :disabled="!(data.approve_state == 2)" icon="tf-recall" @click="cancelApprove(data)">撤回</c-table-button>
						<c-table-button v-if="auth('b_stockin_print')" v-lock="lock('b_stockin_print')" icon="tf-print" @click="$refs.view.exportByTemplate(data.id,view_id)">打印</c-table-button>
						<c-table-button v-if="auth('b_stockin_delete')" v-lock="lock('b_stockin_delete')" icon="tf-trash" color="red" @click="remove(data)">删除</c-table-button>
					</template>
				</c-table-column>
			</view-list>
			<!--创建、编辑入库单信息弹窗-->
			<stockin-edit ref="stockinEdit" @resolve="$refs.view.update()"></stockin-edit>
		</module>
	</page>
</template>

<script>
	import {mapState} from "vuex";
	import stockinEdit from "@/pages/storage/stockin_edit.vue";

	export default {
		components: {stockinEdit},
		computed: {
			// 获取dictName选项数据
			...mapState(['systemConfig'])
		},
		data() {
			return {
				workType: 4,
				view_id: 10005
			}
		},
		methods: {
			/*******搜索业务分类*****************/
			searchOrderClassify(keyword, resolve){
				this.request({
					url:'/system/native/options',
					data: {
						options_code:'STOCKIN_CLASSIFY'
					},
					success:data => {
						resolve(data);
					}
				})
			},
			
			/*******搜索【客户】下拉框信息*****************/
			searchCustomer(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'CUSTOMER',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},
			/*******搜索【供应商】下拉框信息*****************/
			searchSupplier(keyword, resolve){
			    this.request({
			        url:'/system/options',
			        data: {
			            options_code:'SUPPLIER',
			            keyword: keyword
			        },
			        success:data => {
			            resolve(data);
			        }
			    })
			},

			/******删除***********/
			remove(data){
				if(data){
					this.$confirm({
						message:'确认删除入库单【'+data.order_code+'】？删除后不可恢复',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/stockin/order/remove',
								data: {id:data.id},
								loading: true,
								success: data => {
									this.$message({
										message:'删除成功',  // 提示内容,
										type: 'success'
									});
									this.$refs.view.refresh();
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}else{
					var ids = [];
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
					this.$confirm({
						message:'确认删除 <font style="color:red">' + ids.length + '</font> 条入库单记录吗？删除后不可恢复',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/stockin/order/remove/batch',
								data: {
									ids: ids
								},
								loading: true,
								success: data => {
									var mess = '删除成功';
									
									let Mtype = 'success';
									let message = mess + data.success_count + '条';
									if(data.fail_count > 0 && data.success_count > 0){
										Mtype = 'warn';
										message += '，失败'+data.fail_count+'条';
									}else if(data.fail_count > 0 && data.success_count == 0){
										Mtype = 'fail'
										message += '，失败'+data.fail_count+'条';
									}else{
										message = mess + data.success_count + '条记录';
									}
									this.$message({
										message: message,  // 提示内容,
										type: Mtype
									});
									//刷新
									this.$refs.view.refresh();
								}
							});
						},
					});
				}
			},

			/******审批***********/
            approve(data){
				if(data){
					this.request({
					    url: '/stockin/order/approve',
					    data: {id:data.id},
					    loading: true,
					    success: data => {
					        this.$message({
					            message:'审批成功',  // 提示内容,
					            type: 'success'
					        });
					        this.$refs.view.refresh();
					    }
					});
				}else{
					var ids = [];
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
					
					this.$confirm({
						message:'确认审批 <font style="color:red">' + ids.length + '</font> 条入库单记录吗？审批后入库数量计入库存数据',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/stockin/order/approve/batch',
								data: {
									ids: ids
								},
								loading: true,
								success: data => {
									var mess = '审批成功';
									
									let Mtype = 'success';
									let message = mess + data.success_count + '条';
									if(data.fail_count > 0 && data.success_count > 0){
										Mtype = 'warn';
										message += '，失败'+data.fail_count+'条';
									}else if(data.fail_count > 0 && data.success_count == 0){
										Mtype = 'fail'
										message += '，失败'+data.fail_count+'条';
									}else{
										message = mess + data.success_count + '条记录';
									}
									this.$message({
										message: message,  // 提示内容,
										type: Mtype
									});
									//刷新
									this.$refs.view.refresh();
								}
							});
						},
					});
				}
            },

			/******撤销审批***********/
            cancelApprove(data){
				if(data){
					this.$confirm({
						message:'撤回后入库单【'+data.order_code+'】将回滚至待审批状态，相应的入库库存也将回滚，是否确认撤回？',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/stockin/order/cancel',
								data: {id:data.id},
								loading: true,
								success: data => {
									this.$message({
										message:'撤回成功',  // 提示内容,
										type: 'success'
									});
									this.$refs.view.refresh();
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}else{
					var ids = [];
					this.$refs.view.$refs.list.getData('selected').forEach(item => {
						ids.push(item.id);
					});
					
					this.$confirm({
						message:'确认撤回 <font style="color:red">' + ids.length + '</font> 条入库单记录吗？撤回后入库单将回滚至待审批状态，相应的入库库存也将回滚！',  // 提示内容,
						buttonName: '确定',  // 确定按钮文字
						cancelButton: true,  // 是否显示取消按钮
						resolve: () => {
							this.request({
								url: '/stockin/order/cancel/batch',
								data: {
									ids: ids
								},
								loading: true,
								success: data => {
									var mess = '撤回成功';
									
									let Mtype = 'success';
									let message = mess + data.success_count + '条';
									if(data.fail_count > 0 && data.success_count > 0){
										Mtype = 'warn';
										message += '，失败'+data.fail_count+'条';
									}else if(data.fail_count > 0 && data.success_count == 0){
										Mtype = 'fail'
										message += '，失败'+data.fail_count+'条';
									}else{
										message = mess + data.success_count + '条记录';
									}
									this.$message({
										message: message,  // 提示内容,
										type: Mtype
									});
									//刷新
									this.$refs.view.refresh();
								}
							});
						},  // 确定按钮回调
						cancel: () => {},  // 取消按钮回调
					});
				}
			},

			/******选择仓库等响应方法*********/
			warehouseSelectorHandle(data) {
				this.$refs.view.excelImport(Object.assign(data, {
					view_id: this.view_id,
					title: '批量导入【入库单】数据' + (data.warehouse_name ? '（'+data.warehouse_name+'）' : '')
				}));
			},

			/*******导入数据************/
			importData() {
				this.globalDialog('storageInfoSelector', {
					props: {
						workType: this.workType,
						title: '入库'
					}
				}, this.warehouseSelectorHandle);
			},

			/******加载导入业务日志列表**********/
			loadImportLogDetail() {
				//打开模板选择弹窗
				this.globalDialog('importLogDetail', {
					props: {
						workType: this.workType,
						view_id: this.view_id
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
</style>